export enum AuthenticationProvider{
    Google="Google",
    Microsoft="Microsoft",
    Email="Email"
}